import API from './API.js'

export default class Assessments extends API {
  constructor() {
    super('assessments')
  }
}
